import React from 'react';
import CurvedCutoutMedia from './CurvedCutoutMedia';
import LoopingVideo from './LoopingVideo';
import './OnPropertyGuestRoom.css';
import guestRoomBgImageAvif from 'url:../../assets-optimized/redesign/solutions/on-property/onPropertyGuestRoom.avif';
import guestRoomBgImageWebp from 'url:../../assets-optimized/redesign/solutions/on-property/onPropertyGuestRoom.webp';
import guestRoomBgImage from 'url:../../assets-optimized/redesign/solutions/on-property/onPropertyGuestRoom.png';
import guestRoomBgImageMobileAvif from 'url:../../assets-optimized/redesign/solutions/on-property/onPropertyGuestRoom_mobile.avif';
import guestRoomBgImageMobileWebp from 'url:../../assets-optimized/redesign/solutions/on-property/onPropertyGuestRoom_mobile.webp';
import guestRoomBgImageMobile from 'url:../../assets-optimized/redesign/solutions/on-property/onPropertyGuestRoom_mobile.png';
import guestRoomTvWebm from 'url:../../assets-optimized/redesign/solutions/on-property/onProperyTVImageGuestRoom.webm';
import guestRoomTvMp4 from 'url:../../assets-optimized/redesign/solutions/on-property/onProperyTVImageGuestRoom.mp4';

const ArrowDownIcon = () => (
  <svg viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <path
      d='M12 4V20M12 20L6 14M12 20L18 14'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const OnPropertyGuestRoom = () => {
  return (
    <section className='op-guestroom-section' aria-label='On-property guest room tv environment'>
      <div className='op-guestroom-shell'>
        <CurvedCutoutMedia
          className='op-guestroom-media'
          imageSrc={guestRoomBgImage}
          imageAvif={guestRoomBgImageAvif}
          imageWebp={guestRoomBgImageWebp}
          imageMobileAvif={guestRoomBgImageMobileAvif}
          imageMobileWebp={guestRoomBgImageMobileWebp}
          imageMobileSrc={guestRoomBgImageMobile}
          imageAlt='Hotel guest room with a television mounted above a console'
        />

        <div className='op-guestroom-overlay'>
          <h2 className='op-guestroom-large-title'>GUEST ROOM TV</h2>

          <div className='op-guestroom-tv-wrapper'>
            <LoopingVideo
              webm={guestRoomTvWebm}
              mp4={guestRoomTvMp4}
              className='op-guestroom-tv-image'
            />
          </div>
        </div>

        <div className='op-guestroom-card'>
          <h3 className='op-guestroom-card-title'>
            THE BIGGEST SCREEN.
            <br className='desktop-only' /> THE MOST CAPTIVE SCENE.
          </h3>
          <p className='op-guestroom-copy'>
            This is the moment where real connections are made. They are unwinding, ordering in, or
            focused on what's next, your brand becomes part of the in-room ritual.
          </p>
        </div>

        <button
          className='op-guestroom-arrow'
          onClick={() => {
            const nextSection = document.querySelector('.op-guestroom-section').nextElementSibling;
            if (nextSection) {
              const yOffset = -60;
              const elementPosition = nextSection.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.scrollY + yOffset;
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
              });
            }
          }}
          aria-label='Scroll to next section'
          style={{ cursor: 'pointer', background: 'transparent', border: 'none', padding: 0 }}
        >
          <ArrowDownIcon />
        </button>
      </div>
    </section>
  );
};

export default OnPropertyGuestRoom;
